import styled from "styled-components";
import { BASIC_DARK_GRAY } from "../../../constants/colors";
import { BackToTopPageButton } from "../../molecules/BackToTopPageButton";

export const RegistrationMessage: React.FC = () => {
  return (
    <Container>
      <TitleWrapper>送信完了</TitleWrapper>

      <MessageContainer>
        <Message>送信完了しました。</Message>
        <Message2>
          メールアドレスに登録用URLを送信いたします。メールに記載されたURLから、登録してください。
        </Message2>
      </MessageContainer>

      <ButtonWrapper>
        <BackToTopPageButton />
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.div`
  color: ${BASIC_DARK_GRAY};
  padding: 0px 16px 51px 16px;
  max-width: 980px;
  min-width: 375px;
`;

const TitleWrapper = styled.div`
  font-size: 20px;
  font-weight: 600;
  padding: 43px 0 38px 0;
  display: flex;
  line-height: 1em;
  justify-content: center;
  font-family: "Hiragino Sans";
`;

const MessageContainer = styled.div`
  margin-bottom: 320px;
  font-size: 14px;
  font-weight: 300;
`;

const Message = styled.div`
  text-align: center;
  font-family: "Hiragino Sans";
`;

const Message2 = styled.div`
  text-align: center;
  line-height: 21px;
  font-family: "Hiragino Sans";
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 23px;
  button {
    height: auto;
    line-height: 1;
    font-weight: 500;
    font-family: "Hiragino Sans";
  }
`;
